import { PAIR_CATEGORY, type TPairCategory } from "@/types/index";
import type { PairMessage } from "@cronika/proto/common/trading_pb";
import React from "react";

export { PAIR_CATEGORY };

/** Extends TPairCategory with the "all" virtual category */
export const CATEGORY_ALL = "all" as const;
export type TAddCategory = TPairCategory | typeof CATEGORY_ALL;

export type TAddPairProps = {
  activePair: PairMessage | null;
  pairs: PairMessage[];
  setSelectedPairs: (
    pairs: PairMessage[] | ((prev: PairMessage[]) => PairMessage[]),
  ) => void;
  disabledPairs: string[];
  selectPairAsActive?: (pairId: string) => void;
  selectedPairs?: PairMessage[];
  favoritePairs?: PairMessage[];
  onToggleFavorite?: (pair: PairMessage) => void;
  mode?: "add" | "replace";
  onReplace?: (pair: PairMessage) => void;
  children?: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
};

export type TCategory = {
  key: TAddCategory;
  icon: React.ComponentType<{ className?: string }> | string;
  label: string;
};

export const CATEGORY_ICON_MAP: Record<TPairCategory, string> = {
  [PAIR_CATEGORY.FOREX]: "solar:wad-of-money-bold",
  [PAIR_CATEGORY.CRYPTO]: "flowbite:bitcoin-solid",
  [PAIR_CATEGORY.STOCK]: "solar:chart-2-bold",
  [PAIR_CATEGORY.INDEX]: "solar:graph-up-bold",
  [PAIR_CATEGORY.COMMODITY]: "solar:box-bold",
  [PAIR_CATEGORY.FAVORITE]: "solar:star-bold",
};
